import { calculateReadTime } from "@/utils/ReadTime";

export function slugify(text = "") {
  return text
    .toLowerCase()
    .replace(/[^\w]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Strip tags + entities so the word count (and read time) is accurate.
export const stripHtml = (html = "") =>
  html
    .replace(/<[^>]+>/g, " ")
    .replace(/&[a-z]+;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

export const formatReadTime = (html) => {
  const t = calculateReadTime(stripHtml(html), 200, 5);
  return t === "0 min read" ? "1 min read" : t;
};

// Inject stable ids into <h2>/<h3> tags and collect the TOC in one pass.
// Pure string work so it runs identically on the server and client (no
// hydration mismatch) and the ids are part of the HTML — so anchor links
// always resolve via getElementById.
export const buildTocAndHtml = (html) => {
  if (!html) return { html: html ?? "", toc: [] };
  const toc = [];
  const seen = {};

  const out = html.replace(
    /<(h2|h3)([^>]*)>([\s\S]*?)<\/\1>/gi,
    (match, tag, attrs, inner) => {
      const text = stripHtml(inner);
      if (!text) return match;

      // Reuse an existing id if the heading already has one
      const existing = attrs.match(/\bid=["']([^"']+)["']/i);
      let id = existing ? existing[1] : slugify(text) || "section";

      if (seen[id] !== undefined) {
        seen[id] += 1;
        id = `${id}-${seen[id]}`;
      } else {
        seen[id] = 0;
      }

      toc.push({ id, text, level: tag.toLowerCase() });
      return existing ? match : `<${tag}${attrs} id="${id}">${inner}</${tag}>`;
    },
  );

  return { html: out, toc };
};

export const getCategory = (b) =>
  b?.categories_at?.name?.[1] ||
  b?.categories?.[0]?.name ||
  b?.meta_keywords?.split(",")[0]?.trim() ||
  "Imagive";

export const getInitials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase() || "IM";
